import styled from 'styled-components';

export const CompleteTestContainer = styled.div`
  min-width: 500px;

  @media (max-width: 896px) {
    min-width: 100%;
  }
`;
